import { render, staticRenderFns } from "./SingleCompetition.vue?vue&type=template&id=919b9c10&"
import script from "./SingleCompetition.vue?vue&type=script&lang=js&"
export * from "./SingleCompetition.vue?vue&type=script&lang=js&"
import style0 from "./SingleCompetition.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports